import {
    DirectPayForType,
    DirectPromotionGoalUI,
    DirectSpendLimitType,
    DirectStrategyType,
} from '../data-layer/direct/types';

interface ContentPromotionGoalsSettingsProps {
    selectedCounters?: string[];
    selectedGoals?: DirectPromotionGoalUI;
    strategyType?: DirectStrategyType;
    spendLimitType?: DirectSpendLimitType;
    payFor?: DirectPayForType;
}

export const getContentPromotionGoalsSettings = ({
    selectedCounters,
    selectedGoals,
    strategyType,
    spendLimitType,
    payFor,
}: ContentPromotionGoalsSettingsProps) => {
    const selectedGoalsLength = selectedGoals && Object.keys(selectedGoals).length;

    return {
        disableCost:
            strategyType === DirectStrategyType.MAX_CONVERSIONS &&
            (spendLimitType === DirectSpendLimitType.CRR ||
                spendLimitType === DirectSpendLimitType.WEEKLY_LIMIT) &&
            selectedGoalsLength === 1,
        showCostType:
            strategyType === DirectStrategyType.MAX_CONVERSIONS &&
            spendLimitType === DirectSpendLimitType.CRR &&
            selectedGoalsLength !== undefined &&
            selectedGoalsLength > 1,
        isRequiredMetrics:
            strategyType !== DirectStrategyType.MAX_CLICKS ||
            payFor !== DirectPayForType.CLICKS ||
            Boolean(selectedCounters?.length),
    };
};
